import { ConnectorBase } from 'pages/Connectors/types';
import { RetentionSettingsValues } from 'pages/MediaCluster/types';
import { ApiRequest } from '../types';
import secondaryHttpService from '../services/secondary-http.service';
import { API_URLS } from '../app-constants/api';

export const getIntegrationsStatus: ApiRequest = () => secondaryHttpService.get(API_URLS.integrationsStatus(), {});

export const createConnector = (data: ConnectorBase) => secondaryHttpService.post(API_URLS.integrationsStatus(), data);

export const editConnector = (data: ConnectorBase) => secondaryHttpService.put(API_URLS.integrationsStatus(), data);

export const getMediaClusterStatus: ApiRequest = () => secondaryHttpService.get(API_URLS.mediaClusterStatus(), {});

export const SetMediaCluster = (data: RetentionSettingsValues) =>
  secondaryHttpService.post(API_URLS.mediaClusterStatusSettings(), data);

export const getNotificationStats: ApiRequest = () => secondaryHttpService.get(API_URLS.notificationsStats(), {});

export const getMediaClusterSettings: ApiRequest = () => {
  return secondaryHttpService.get(API_URLS.mediaClusterStatusSettings(), {});
};
